import Clarity from "@microsoft/clarity"

const clarityIds = {
    local: "twvkpdqdnl",
    staging: "twvkpdqdnl",
    production: "tywjba1se1"
}

class ClarityInitializer {
    private static _instance: ClarityInitializer | undefined

    private constructor() {
        this.startClarity()
        this.setFlowScope()
    }

    static get instance() {
        if (ClarityInitializer._instance) {
            return this._instance
        }
        this._instance = globalThis.IS_CLARITY_ENABLED
            ? new ClarityInitializer()
            : undefined

        return this._instance
    }

    private startClarity() {
        Clarity.init(clarityIds[globalThis.ENV])
    }

    private setFlowScope() {
        Clarity.setTag("template", globalThis.GET_THEME_NAME)

        if (globalThis.IS_PASSWORDLESS) {
            Clarity.setTag("flow", "passwordless")

            return
        }
        Clarity.setTag("flow", "emailAndPassword")
    }

    setCustomEvent(eventName: string) {
        Clarity.event(eventName)
    }
}

export const clarity = ClarityInitializer.instance
